import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/* eslint-disable react/destructuring-assignment */
import React, { Component } from "react";
import ReactDOMServer from "react-dom/server";
import noop from "lodash/noop";
import { PageletContainer as GenericPageletContainer, RemotePagelet } from "@xo-union/pagelet";
import PropTypes from "prop-types";
import ReactPagelet from "./ReactPagelet/index.js";
export default class PageletContainer extends Component {
  constructor() {
    super(...arguments);
    /**
     * Remove ability to change props that may cause a re-render. If they change, that would trigger
     * a re-render which would unmount the pagelet without a proper clean up
     */
    _defineProperty(this, "containerId", this.props.containerId);
    _defineProperty(this, "links", this.props.links);
    _defineProperty(this, "ssi", this.props.ssi);
    _defineProperty(this, "renderPlaceholder", this.props.renderPlaceholder);
    _defineProperty(this, "renderError", this.props.renderError);
    _defineProperty(this, "pageletContainer", new GenericPageletContainer(this.containerId, {
      errorPagelet: new ReactPagelet(this.renderError),
      props: this.props.pageletProps
    }));
    _defineProperty(this, "remotePagelet", new RemotePagelet({
      links: this.links,
      jsExportName: this.props.exportName
    }));
  }
  componentDidMount() {
    this.pageletContainer.addEventListener('error', this.props.onError);
    this.pageletContainer.mount(this.remotePagelet);
  }
  componentDidUpdate() {
    this.pageletContainer.setProps(this.props.pageletProps);
  }
  componentWillUnmount() {
    this.pageletContainer.unmount();
  }
  render() {
    if (this.ssi) {
      /* eslint-disable react/no-danger */

      const pageletHTML = ReactDOMServer.renderToStaticMarkup( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        "data-pagelet-role": "placeholder"
      }, this.renderPlaceholder())));
      return /*#__PURE__*/React.createElement("div", {
        "data-pagelet-container-id": this.containerId,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
          __html: `<!--#include virtual="${this.links.ssi}" -->${pageletHTML}`
        }
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      "data-pagelet-container-id": this.containerId
    }, /*#__PURE__*/React.createElement("div", {
      "data-pagelet-role": "placeholder"
    }, this.renderPlaceholder()));
  }
}
_defineProperty(PageletContainer, "defaultProps", {
  exportName: 'default',
  pageletProps: {},
  ssi: false,
  renderPlaceholder: () => 'Loading...',
  renderError: () => 'There was an error loading this part of the page. Try again soon.',
  onError: noop
});
process.env.NODE_ENV !== "production" ? PageletContainer.propTypes = {
  /**
   * Unique ID to assign to pagelet
   */
  containerId: PropTypes.string.isRequired,
  /**
   * Asset links
   */
  links: PropTypes.shape({
    css: PropTypes.shape({
      toString: PropTypes.func.isRequired
    }),
    js: PropTypes.shape({
      toString: PropTypes.func.isRequired
    }),
    ssi: PropTypes.shape({
      toString: PropTypes.func.isRequired
    })
  }).isRequired,
  /**
   * Name of export where pagelet is implemented in remote JS
   * */
  exportName: PropTypes.string,
  /**
   * Props to pass to pagelet
   * */
  pageletProps: PropTypes.shape({}),
  /**
   * Enable SSI rendering (for server side rendering)
   */
  ssi: PropTypes.bool,
  /**
   * Render function for pagelet placeholder. This will be rendered while the pagelet loads
   * if the pagelet is rendered on the client side.
   */
  renderPlaceholder: PropTypes.func,
  /**
   * Render function for pagelet error. This will be rendered when an error occurs. Rendering the error
   * can be prevented via the `onError` callback. For example, when the pagelet is fully rendered, it may
   * not page sense to render an error because the broken pagelet may still provide a usable experience
   * (via links, etc).
   */
  renderError: PropTypes.func,
  /**
   * Handle pagelet container error
   */
  onError: PropTypes.func
} : void 0;